import { useState } from 'react'

import ArrowButton from '~/checklist/components/ArrowButton'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface MethodCardProps {
  index: number
  srcKey?: string
  title: string
  description: string
}

export default function MethodCard({ srcKey, title, description, index }: MethodCardProps): React.ReactElement {
  const [isExpanded, setExpand] = useState(false)

  const onClick = (): void => {
    setExpand(!isExpanded)
  }

  return (
    <div className="flex-col w-full py-2 max-w-lg mx-auto ">
      {srcKey && (
        <div className="flex justify-center">
          <ResponsiveImage fit="contain" height={200} imageClassName="w-16 h-7" srcKey={srcKey} width={400} />
        </div>
      )}
      <div className="flex border-2 border-white p-3 mt-2 rounded cursor-pointer" onClick={onClick}>
        <div className="flex-none w-6">
          <h1 className="text-white text-4 md:text-5 font-bold text-left">{index + 1}.</h1>
        </div>
        <div className="flex-col">
          <div className="flex w-full">
            <h1 className="text-white text-4 md:text-5 font-bold ">{title}</h1>
          </div>
          <div
            className={`flex w-full mt-1 transition-all duration-300 origin-top ${
              isExpanded ? 'scale-y-100 max-h-800' : 'scale-y-0 max-h-0'
            }`}
          >
            <div className="text-white text-sm whitespace-normal" dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
        <div className="flex-none w-6 pt-2">
          <ArrowButton color="text-white" expanded={isExpanded} size={17} />
        </div>
      </div>
    </div>
  )
}
